import { render, staticRenderFns } from "./webWork.vue?vue&type=template&id=8696cf72&scoped=true&"
import script from "./webWork.vue?vue&type=script&lang=js&"
export * from "./webWork.vue?vue&type=script&lang=js&"
import style0 from "./webWork.vue?vue&type=style&index=0&id=8696cf72&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8696cf72",
  null
  
)

export default component.exports